"use client";

import { Render } from "@measured/puck";
import blocks from "@admin/config/blocks/index";
import categories from "@admin/config/categories";

export function CmsRender({ data }: { data: any }) {
  const renderConfig = {
    components: blocks as any,
    root: {
      render: ({ children }: { children: React.ReactNode }) => <>{children}</>,
    },
    categories,
  };

  return (
    <Render
      config={renderConfig}
      data={data}
    />
  );
}
